import * as React from 'react';
import { conf } from './conf';
import { formatPrice } from '@/components/EcocreditsMonthlyMadness/utils';
import { getMemberListProducts } from '@/service/vip';

import type { IProductItem } from '@/components/EcocreditsMonthlyMadness/type';

const { useState, useEffect } = React;

export const useProductList = (locale: string) => {
    const [loading, setLoading] = useState(true);
    const [productList, setProductList] = useState<IProductItem[]>([]);

    const config = conf[locale] || null;

    useEffect(() => {
        const getVids = () => config?.map((item) => item.variantId);

        if (!getVids()) return;

        getMemberListProducts(
            {
                variantIds: getVids(),
            },
            locale,
        )
            .then((res) => {
                if (!res || res.code !== '0') return;

                const sortedList = [];
                const data = res.data?.map((item: any) => {
                    const newItem = { ...item };

                    if (parseInt(newItem.compareAtPrice) > parseInt(newItem.price)) {
                        newItem.discount = `${Math.round((1 - parseInt(newItem.price) / parseInt(newItem.compareAtPrice)) * 100)}%`;
                    } else {
                        newItem.discount = '';
                    }

                    const confItem = config.find((ele: any) => ele.productId === item.productId);

                    newItem.shopifyTitle = item.skuTitle !== 'Default Title' ? item.skuTitle : item.productTitle;
                    newItem.link_buy = `https://${locale}.ecoflow.com/cart/${item.variantId}:1?channel=buy_button`;
                    newItem.price = formatPrice(String(item.price), locale);
                    newItem.compareAtPrice = item.compareAtPrice ? formatPrice(String(item.compareAtPrice), locale) : '';
                    newItem.points = Math.floor((parseInt(item.price) / 150) * 5);

                    if (confItem) {
                        newItem.desc = confItem.desc;
                        newItem.productUrl = confItem.productUrl;
                        newItem.shopifyHanle = `https://${locale}.ecoflow.com/products/${newItem.handle}?variant=${confItem.variantId}`;
                        if (locale === 'jp') {
                            newItem.shopifyTitle = confItem.title;
                        }
                    }
                    return newItem;
                });

                for (const item in config) {
                    sortedList.push(data.find((ele: any) => ele.productId === config[item].productId));
                }

                setProductList(sortedList);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [locale, config]);

    return { productList, loading };
};
